// Feature pages (/features/{slug}), in menu order. Used by the site header's
// Features dropdown, the /features index, the "more features" row on each
// feature page, and nuxt.config.ts (prerender list). The page copy itself lives
// in content/8.features/{slug}.md; keep slugs in sync with those files.
export const FEATURE_LINKS = [
  {
    slug: 'links',
    label: 'Links',
    description: 'Unlimited platform links and custom links to any URL.',
    icon: 'i-lucide-link'
  },
  {
    slug: 'editor',
    label: 'Editor',
    description: 'Design your page on the page itself and see every change live.',
    icon: 'i-lucide-mouse-pointer-click'
  },
  {
    slug: 'integrations',
    label: 'Integrations',
    description: 'YouTube, Twitch, and Discord that update themselves.',
    icon: 'i-lucide-plug'
  },
  {
    slug: 'music-and-clips',
    label: 'Music and clips',
    description: 'A music player and video clips that play on your page.',
    icon: 'i-lucide-music'
  },
  {
    slug: 'analytics',
    label: 'Analytics',
    description: 'Views, clicks, top links, and live visitors, built in.',
    icon: 'i-lucide-chart-line'
  },
  {
    slug: 'skins',
    label: 'Skins',
    description: 'Community themes you apply in one click and make your own.',
    icon: 'i-lucide-palette'
  },
  {
    slug: 'custom-domain',
    label: 'Custom domain',
    description: 'Put your page on a domain you own, with SSL included.',
    icon: 'i-lucide-globe'
  },
  {
    slug: 'friends-and-comments',
    label: 'Friends and comments',
    description: 'Let visitors leave a message and link your friends\' pages.',
    icon: 'i-lucide-message-circle'
  },
  {
    slug: 'achievements',
    label: 'Achievements',
    description: 'Badges you earn and choose to show on your page.',
    icon: 'i-lucide-award'
  },
  {
    slug: 'leaderboard',
    label: 'Leaderboard',
    description: 'The most viewed pages on mychar.gg, weekly and all-time.',
    icon: 'i-lucide-trophy'
  },
  {
    slug: 'games-and-setup',
    label: 'Games and setup',
    description: 'Your game library with in-game handles and the gear you use.',
    icon: 'i-lucide-gamepad-2'
  }
] as const

export type FeatureSlug = typeof FEATURE_LINKS[number]['slug']

export function featurePath(slug: string): string {
  return `/features/${slug}`
}
